<script>
  import Button from './Button.svelte'
</script>

<div class="text-center bg-[#f2f2f2] p-4">
  <div class="w-11/12 md:w-7/11 m-auto">
    <h2 class="font-poppins text-xl font-bold pt-6">
      E quanto você vai investir para aprender francês em até 3 meses e realizar
      seu sonho de ir para a França falando a língua?
    </h2>
    <h2 class="font-poppins text-xl pt-6">
      Infinitamente menos do que todo o tempo e dinheiro que você vem perdendo
      por não ter uma rotina de estudos estruturada e um método claro que te
      faça destravar de vez na língua
    </h2>
    <h2 class="font-poppins text-xl pt-6">
      Aproveite agora e adquira o curso com todos os bônus de R$ 897,00 POR
      APENAS:
    </h2>
    <h2 class="text-[#478E88] font-poppins font-extrabold text-5xl pt-6">
      12x R$ 19,19
    </h2>
    <h2 class="font-poppins font-extrabold text-2xl w-2/4 md:w-1/4 m-auto pt-6">
      ou à vista
      <span class="text-[#478E88]">R$ 197,00</span>
      por tempo limitado
    </h2>
  </div>
  <Button />
  <p class="font-bold text-base mt-[-30px]">
    *Você será direcionado para a página de pagamento
  </p>

</div>
